import PAGINATION from '@sdk/helpers/misc/pagination';

import crudlModuleGenerator from '@/_CRUDL/modules/generator';

const stores = crudlModuleGenerator('stores');

export const INITIAL_STORES_FILTERS = {
  CRUDL_append: false,

  q: '',
  sort: 'name_asc',
  per_page: PAGINATION.PER_PAGE,
  publicable: null,
};

export default {
  ...stores,
  state: {
    ...stores.state,
    list: {
      ...stores.state.list,
      filters: {
        ...INITIAL_STORES_FILTERS,
      },
    },
  },
};
